export function flattenSearchParams(params)
{
	let parameters = {};
	Object.keys(params).forEach((key) => {
		parameters[key] = params[key][0];
	});
	return parameters;
	
}
